import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const SignOutIcon = (props) => {
  const {fill = 'var(--primary)'} = props;
  return (
    <SvgIcon {...props} width="23.681" height="19.704" viewBox="0 0 23.681 19.704">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round"
           strokeWidth="1.5px">
        <g transform="translate(-1162.25 -69.25)">
          <path d="M113.791,689.653v1.138a3.413,3.413,0,0,1-3.413,3.413h-7.964A3.413,3.413,0,0,1,99,690.791V679.413A3.413,3.413,0,0,1,102.413,676h7.964a3.413,3.413,0,0,1,3.413,3.413v1.138"
                transform="translate(1064 -606)"/>
          <path d="M110.378,689.1l4.551-4.551m0,0L110.378,680m4.551,4.551H99"
                transform="translate(1069.942 -605.449)"/>
        </g>
      </svg>
    </SvgIcon>
  );
};

SignOutIcon.propTypes = {}

SignOutIcon.defaultProps = {}

export default SignOutIcon;
